(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-crosstrainer-de"]) return;
  try {
    
document.addEventListener('click', (event) => {
 const button = event.target.closest('[data-lp-direction]');
 if (!button) return;
 const carousel = document.getElementById(button.getAttribute('aria-controls'));
 if (!carousel) return;
 carousel.scrollBy({left: Number(button.dataset.lpDirection) * carousel.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

function initCrosstrainerPagination(){document.querySelectorAll(".lp-crosstrainer-pagination[data-lp-for]").forEach(nav=>{const track=document.getElementById(nav.dataset.lpFor);if(!track)return;const update=()=>{if(!track.clientWidth)return;const count=Math.max(1,Math.ceil((track.scrollWidth-track.clientWidth-2)/track.clientWidth)+1);if(nav.children.length!==count){nav.replaceChildren();for(let i=0;i<count;i++){const dot=document.createElement("button");dot.type="button";dot.setAttribute("aria-label","Produktseite "+(i+1)+" von "+count);dot.addEventListener("click",()=>track.scrollTo({left:i*track.clientWidth,behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"instant":"smooth"}));nav.append(dot)}}const selected=Math.min(count-1,Math.round(track.scrollLeft/track.clientWidth));[...nav.children].forEach((dot,i)=>dot.setAttribute("aria-current",String(i===selected)));nav.hidden=count<2};track.addEventListener("scroll",update,{passive:true});window.addEventListener("resize",update,{passive:true});update()})}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initCrosstrainerPagination,{once:true});else initCrosstrainerPagination();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serviceformular"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fieldIds = ['custom#gclid', 'custom#gbraid', 'custom#wbraid', 'custom#klickzeit'];
    let shadowObserver;

    function hideTrackingFields() {
      const host = document.querySelector('.serviceformular-main shopify-forms-embed');
      const root = host && host.shadowRoot;
      if (!root) return false;

      if (!shadowObserver) {
        shadowObserver = new MutationObserver(hideTrackingFields);
        shadowObserver.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-current-step']
        });
      }

      const intro = host.closest('.serviceformular-left')?.querySelector('.serviceformular-intro');
      const formRoot = root.querySelector('[data-form-root]');
      if (intro) {
        intro.hidden = formRoot?.getAttribute('data-current-step') === 'success';
      }

      fieldIds.forEach((id) => {
        const field = root.getElementById(id);
        if (field && field.parentElement && field.parentElement.style.display !== 'none') {
          field.parentElement.style.display = 'none';
        }
      });
      return true;
    }

    if (hideTrackingFields()) return;

    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (hideTrackingFields() || attempts >= 100) clearInterval(timer);
    }, 100);
  })();

  } catch(e) { console.error(e); }
})();
})();
